// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OrganizationNotesPanel_panel__6t7Rz {
  padding: 18px 20px 20px;
}

.OrganizationNotesPanel_header__YS4ku {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}

.OrganizationNotesPanel_header__YS4ku h2 {
  margin: 0;
  color: #173f56;
  font-size: 1rem;
}

.OrganizationNotesPanel_header__YS4ku p {
  margin: 4px 0 0;
  color: #71808b;
  font-size: 0.78rem;
}

.OrganizationNotesPanel_form__2gvg1 {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 10px;
  align-items: end;
  margin-bottom: 16px;
}

.OrganizationNotesPanel_form__2gvg1 textarea {
  width: 100%;
  min-height: 58px;
  resize: vertical;
  box-sizing: border-box;
  padding: 12px 14px;
  border: 1px solid #d7dfe5;
  border-radius: 10px;
  background: #f6f7f8;
  color: #243746;
  font: inherit;
  font-size: 0.88rem;
  line-height: 1.4;
}

.OrganizationNotesPanel_form__2gvg1 textarea:focus {
  outline: 2px solid rgba(43, 103, 132, 0.2);
  border-color: #2b6784;
}

.OrganizationNotesPanel_form__2gvg1 textarea::placeholder {
  color: #a0aab2;
}

.OrganizationNotesPanel_form__2gvg1 button {
  min-width: 82px;
  min-height: 38px;
  padding: 8px 16px;
  border: 0;
  border-radius: 9px;
  background: #2b6784;
  color: #fff;
  font: inherit;
  font-weight: 600;
  cursor: pointer;
}

.OrganizationNotesPanel_form__2gvg1 button:disabled {
  opacity: 0.55;
  cursor: default;
}

.OrganizationNotesPanel_list__9xugQ {
  display: grid;
  gap: 12px;
}

.OrganizationNotesPanel_noteCard__C0VEH {
  padding: 14px 14px 12px;
  border: 1px solid #dfe5e9;
  border-radius: 10px;
  background: #fbfcfd;
}

.OrganizationNotesPanel_noteContent__vM5-B {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.OrganizationNotesPanel_noteContent__vM5-B p {
  margin: 0;
  color: #30495b;
  font-size: 0.88rem;
  line-height: 1.45;
  white-space: pre-wrap;
}

.OrganizationNotesPanel_bullet__Qe86G {
  flex: 0 0 auto;
  color: #2b6784;
  font-size: 1.25rem;
  line-height: 1;
}

.OrganizationNotesPanel_noteCard__C0VEH footer {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 14px;
  margin: 8px 0 0 20px;
  color: #93a0aa;
  font-size: 0.76rem;
}

.OrganizationNotesPanel_state__deBPv,
.OrganizationNotesPanel_empty__NPf\\+r,
.OrganizationNotesPanel_error__-e5qp {
  margin: 18px 0 4px;
  text-align: center;
  font-size: 0.84rem;
}

.OrganizationNotesPanel_state__deBPv,
.OrganizationNotesPanel_empty__NPf\\+r {
  color: #71808b;
}

.OrganizationNotesPanel_error__-e5qp {
  color: #b4232f;
}

@media (max-width: 640px) {
  .OrganizationNotesPanel_panel__6t7Rz {
    padding: 14px;
  }

  .OrganizationNotesPanel_form__2gvg1 {
    grid-template-columns: 1fr;
  }

  .OrganizationNotesPanel_form__2gvg1 button {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Overview/OrganizationNotesPanel.module.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,oBAAoB;EACpB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;;EAGE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".panel {\r\n  padding: 18px 20px 20px;\r\n}\r\n\r\n.header {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  gap: 16px;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.header h2 {\r\n  margin: 0;\r\n  color: #173f56;\r\n  font-size: 1rem;\r\n}\r\n\r\n.header p {\r\n  margin: 4px 0 0;\r\n  color: #71808b;\r\n  font-size: 0.78rem;\r\n}\r\n\r\n.form {\r\n  display: grid;\r\n  grid-template-columns: minmax(0, 1fr) auto;\r\n  gap: 10px;\r\n  align-items: end;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.form textarea {\r\n  width: 100%;\r\n  min-height: 58px;\r\n  resize: vertical;\r\n  box-sizing: border-box;\r\n  padding: 12px 14px;\r\n  border: 1px solid #d7dfe5;\r\n  border-radius: 10px;\r\n  background: #f6f7f8;\r\n  color: #243746;\r\n  font: inherit;\r\n  font-size: 0.88rem;\r\n  line-height: 1.4;\r\n}\r\n\r\n.form textarea:focus {\r\n  outline: 2px solid rgba(43, 103, 132, 0.2);\r\n  border-color: #2b6784;\r\n}\r\n\r\n.form textarea::placeholder {\r\n  color: #a0aab2;\r\n}\r\n\r\n.form button {\r\n  min-width: 82px;\r\n  min-height: 38px;\r\n  padding: 8px 16px;\r\n  border: 0;\r\n  border-radius: 9px;\r\n  background: #2b6784;\r\n  color: #fff;\r\n  font: inherit;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n}\r\n\r\n.form button:disabled {\r\n  opacity: 0.55;\r\n  cursor: default;\r\n}\r\n\r\n.list {\r\n  display: grid;\r\n  gap: 12px;\r\n}\r\n\r\n.noteCard {\r\n  padding: 14px 14px 12px;\r\n  border: 1px solid #dfe5e9;\r\n  border-radius: 10px;\r\n  background: #fbfcfd;\r\n}\r\n\r\n.noteContent {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  gap: 10px;\r\n}\r\n\r\n.noteContent p {\r\n  margin: 0;\r\n  color: #30495b;\r\n  font-size: 0.88rem;\r\n  line-height: 1.45;\r\n  white-space: pre-wrap;\r\n}\r\n\r\n.bullet {\r\n  flex: 0 0 auto;\r\n  color: #2b6784;\r\n  font-size: 1.25rem;\r\n  line-height: 1;\r\n}\r\n\r\n.noteCard footer {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 8px 14px;\r\n  margin: 8px 0 0 20px;\r\n  color: #93a0aa;\r\n  font-size: 0.76rem;\r\n}\r\n\r\n.state,\r\n.empty,\r\n.error {\r\n  margin: 18px 0 4px;\r\n  text-align: center;\r\n  font-size: 0.84rem;\r\n}\r\n\r\n.state,\r\n.empty {\r\n  color: #71808b;\r\n}\r\n\r\n.error {\r\n  color: #b4232f;\r\n}\r\n\r\n@media (max-width: 640px) {\r\n  .panel {\r\n    padding: 14px;\r\n  }\r\n\r\n  .form {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .form button {\r\n    width: 100%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panel": `OrganizationNotesPanel_panel__6t7Rz`,
	"header": `OrganizationNotesPanel_header__YS4ku`,
	"form": `OrganizationNotesPanel_form__2gvg1`,
	"list": `OrganizationNotesPanel_list__9xugQ`,
	"noteCard": `OrganizationNotesPanel_noteCard__C0VEH`,
	"noteContent": `OrganizationNotesPanel_noteContent__vM5-B`,
	"bullet": `OrganizationNotesPanel_bullet__Qe86G`,
	"state": `OrganizationNotesPanel_state__deBPv`,
	"empty": `OrganizationNotesPanel_empty__NPf+r`,
	"error": `OrganizationNotesPanel_error__-e5qp`
};
export default ___CSS_LOADER_EXPORT___;
